/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect, useRef,Fragment } from 'react';
import { Input, Form, Select, Row, Button, message } from 'antd';
import './reportConfig.css';

const { Option } = Select;
const { TextArea } = Input;

const ApiCustomization = (props) => {
  const [apiProperties, setApiProperties] = useState(props.apiProperties || []);
  const [inputFields, setInputFields] = useState([]);
  const [payloadFields, setPayloadFields] = useState([]);
  const userRef = useRef(null);

  useEffect(() => {
    if (props.apiProperties !== apiProperties) {
      setApiProperties(props.apiProperties);
    }
  }, [props.apiProperties]);

  const handleFieldChange = (value, colName) => {
    setApiProperties((prev) => {
      const updatedProperties = { ...prev, [colName]: value };
      props.jsonSaveObject(updatedProperties, 'api');
      return updatedProperties;
    });
  };

  const handlePayloadChange = (key, event, objectkey) => {
    setApiProperties((prev) => {
      const updatedPayload = { ...prev.payload };
      if (objectkey === 'key') {
        updatedPayload[event.target.value] = updatedPayload[key];
        delete updatedPayload[key];
      } else if (objectkey === 'value') {
        updatedPayload[key] = event.target.value;
      }
      return { ...prev, payload: updatedPayload };
    });
    props.jsonSaveObject(apiProperties, 'api');
  };

  const handleAddPayloadFields = () => {
    setPayloadFields((prev) => [...prev, { reportKey: '', reportValue: '' }]);
  };

  const handleInputChange = (index, event) => {
    const updatedFields = [...inputFields];
    updatedFields[index][event.target.name] = event.target.value;
    setInputFields(updatedFields);
  };

  const handleRemoveFields = (index) => {
    const updatedFields = [...inputFields];
    updatedFields.splice(index, 1);
    setInputFields(updatedFields);
  };

  const submitPayload = () => {
    const updatedPayload = {};
    inputFields.forEach((item) => {
      updatedPayload[item.reportKey] = item.reportValue;
    });
    setApiProperties((prev) => ({ ...prev, payload: updatedPayload }));
    // props.jsonSaveObject(apiProperties, "api");
  };

  const UpdatePayload = () => {
    const updatedApiProperties = { ...apiProperties };
    
    payloadFields.forEach((item) => {
      updatedApiProperties.payload[item.reportKey] = item.reportValue;
    });

    setPayloadFields([]);
    setApiProperties(updatedApiProperties);
    props.jsonSaveObject(updatedApiProperties, 'api');
  };

  // Handle Payload Input Change
  const handlePayloadInputChange = (index, event) => {
    const updatedPayloadFields = [...payloadFields];
    updatedPayloadFields[index][event.target.name] = event.target.value;
    setPayloadFields(updatedPayloadFields);
  };

  // Handle Add Fields
  const handleAddFields = () => {
    setInputFields(prevFields => [
      ...prevFields, 
      { reportKey: '', reportValue: '' }
    ]);
  };

  // Handle Payload Remove Fields
  const handlePayloadRemoveFields = (index) => {
    setPayloadFields(prevFields => 
      prevFields.filter((_, fieldIndex) => fieldIndex !== index)
    );
  };
  const handleMainPayloadRemoveFields = (key) => {
    setApiProperties((prev) => {
      const updatedPayload = { ...prev.payload };
      delete updatedPayload[key]; // Remove the payload entry by key
      return { ...prev, payload: updatedPayload }; // Return the updated apiProperties
    });
  };

  // Add Payload
  const addPayload = () => {
    const initialInputFields = [
      {
        reportKey: '',
        reportValue: ''
      }
    ];

    setInputFields(initialInputFields);
  };

  const apiSave = () => {
    userRef.current.validateFields().then(async () => {
      props.jsonSaveObject(apiProperties, 'api');
      message.success('Api Validated Successfully');
    });
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 2 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 }
    }
  };
  // let {item} = apiProperties;
  const payloadMethod = '';
  return (
    <div style={{}}>
      <div style={{ margin: '50px' }}>
        {apiProperties ? (
          <div>
            <Form
              {...formItemLayout}
              layout="vertical"
              ref={userRef}
              name="user_form"
              initialValues={apiProperties || {}}
            >
              <Form.Item
                label="Uri :"
                name="uri"
                rules={[{ required: true, message: 'Please Provide Uri!' }]}
              >
                <Input
                  value={apiProperties.uri}
                  style={{ width: '100%' }}
                  // type="number"
                  onChange={(e) => handleFieldChange(e.target.value, 'uri')}
                />
              </Form.Item>
              <Form.Item
                label="Method :"
                name={'method'}
                rules={[{ required: true, message: 'Please Select Method!' }]}
              >
                <Select
                  value={apiProperties.method}
                  style={{ width: '100%' }}
                  onSelect={(value) => handleFieldChange(value, 'method')}
                >
                  <Option value="GET">GET</Option>
                  <Option value="POST">POST</Option>
                </Select>
              </Form.Item>
              {payloadMethod === 'POST' || apiProperties.method === 'POST' ? (
                <Form.Item label="Payload :">
                  {Object.entries(apiProperties.payload).length > 0 ? (
                    Object.entries(apiProperties.payload).map(([key, value], index) => (
                      <Row key={index}>
                        <input
                          type="text"
                          className="form-control"
                          id="reportKey"
                          name="reportKey"
                          value={key}
                          onChange={(e) => handlePayloadChange(key, e, 'key')}
                        />
                        {/* <label htmlFor="reportName">Last Name</label> */}
                        <input
                          type="text"
                          className="form-control"
                          id="reportValue"
                          name="reportValue"
                          value={value}
                          onChange={(e) => handlePayloadChange(key, e, 'value')}
                        />
                        <Button
                          className="btn-link"
                          type="Button"
                          onClick={() => handleMainPayloadRemoveFields(key)}
                        >
                          -
                        </Button>
                        {Object.keys(apiProperties.payload).length - 1 === index ? (
                          <Button
                            className="btn-link"
                            type="Button"
                            onClick={() => handleAddPayloadFields()}
                          >
                            +
                          </Button>
                        ) : null}
                      </Row>
                    ))
                  ) : (
                    <div>
                      <Button onClick={(e) => addPayload(e)}>Add Payload</Button>
                      {inputFields.length > 0 &&
                        inputFields.map((item, index) => (
                          <Fragment key={`${item}~${index}`}>
                            <div>
                              {/* <label htmlFor="reportKey">First Name</label> */}
                              {/* {inputFields.length} */}
                              {/* {index} */}

                              <input
                                type="text"
                                className="form-control"
                                id="reportKey"
                                name="reportKey"
                                value={item.reportKey}
                                onChange={(e) => handleInputChange(index, e)}
                              />

                              {/* <label htmlFor="reportName">Last Name</label> */}
                              <input
                                type="text"
                                className="form-control"
                                id="reportValue"
                                name="reportValue"
                                value={item.reportValue}
                                onChange={(e) => handleInputChange(index, e)}
                              />

                              <Button
                                className="btn-link"
                                type="Button"
                                onClick={() => handleRemoveFields(index)}
                              >
                                -
                              </Button>
                              {inputFields.length - 1 === index ? (
                                <Button
                                  className="btn-link"
                                  type="Button"
                                  onClick={() => handleAddFields()}
                                >
                                  +
                                </Button>
                              ) : null}
                            </div>
                            <div>
                              <Button onClick={() => submitPayload()}>Submit</Button>
                            </div>
                          </Fragment>
                        ))}
                    </div>
                  )}
                  {payloadFields && payloadFields.length > 0
                    ? payloadFields.map((item, index) => (
                        <Fragment key={`${item}~${index}`}>
                          <div>
                            {/* <label htmlFor="reportKey">First Name</label> */}

                            <input
                              type="text"
                              className="form-control"
                              id="reportKey"
                              name="reportKey"
                              value={item.reportKey}
                              onChange={(e) => handlePayloadInputChange(index, e)}
                            />

                            {/* <label htmlFor="reportName">Last Name</label> */}
                            <input
                              type="text"
                              className="form-control"
                              id="reportValue"
                              name="reportValue"
                              value={item.reportValue}
                              onChange={(e) => handlePayloadInputChange(index, e)}
                            />

                            <Button
                              className="btn-link"
                              type="Button"
                              onClick={() => handlePayloadRemoveFields(index)}
                            >
                              -
                            </Button>
                            {payloadFields.length - 1 === index ? (
                              <Button
                                className="btn-link"
                                type="Button"
                                onClick={() => handleAddPayloadFields()}
                              >
                                +
                              </Button>
                            ) : null}
                          </div>

                          {payloadFields.length > 0 ? (
                            <Button type="primary" onClick={(e) => UpdatePayload(e)}>
                              UpdatePayload
                            </Button>
                          ) : null}
                        </Fragment>
                      ))
                    : null}
                </Form.Item>
              ) : null}
              <Form.Item
                label="Query :"
                name="query"
                rules={[{ required: false, message: 'Please Provide Query!' }]}
              >
                <TextArea
                  type={TextArea}
                  value={apiProperties.query}
                  // style={{ width: '550px' }}
                  // type="number"
                  onChange={(e) => handleFieldChange(e.target.value, 'query')}
                />
              </Form.Item>
            </Form>
            <div>
              <Button type="primary" onClick={(e) => apiSave(e)}>
                Validate Json
              </Button>{' '}
              {/*  */}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
  };

export default ApiCustomization;